angular
  .module 'gym.components'
  .directive 'financialsWidget', ->
    restrict: 'EA'
    template: require('templates/components/dashboard/financials_widget.html.slim')
    scope:
      privacyModeEnabled: '='
      gym: '='
      netRevenueVisible: '='
      monthlyRevenueVisible: '='
    controller: ($scope, Dashboard, EmploymentService) ->
      $scope.isLoading = true
      $scope.currency = $scope.gym.currency_symbol
      $scope.permissions = EmploymentService.get().permissions

      $scope.$on 'dashboard:refresh', () ->
        load()

      load = ->
        Dashboard.customGET('financials').then (data) ->
          $scope.revenue = data.plain()
          # Store graph data for React component
          $scope.netRevenueGraphData = data.net_revenue_graph_data
          $scope.mrrGraphData = data.mrr_graph_data

      load()
